import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";

export const saveTimetableUrl = createAsyncThunk(
    "api/Calendar/saveTimetableUrl",
    async (url, { dispatch }) => {
        try {
            await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/saveTimetableUrl`,
                { url: url },
                { headers: { "Content-Type": "application/json" } }
            );
            // Optionally dispatch a success action if needed
        } catch (error) {
            // Handle error
            console.error("Failed to save timetable URL", error);
        }
    }
);